// 🔧 ga_events.js
// ✅ Purpose: Central GA4 event names for LGV conversion and engagement tracking
// ✅ Features:
// - Standardizes important GA4 event names
// - Prevents typo-driven analytics fragmentation
// - Supports website funnel, voting funnel, commerce funnel, Passport funnel, and event-interest funnel
// - Keeps event names reusable across pages

export const GA_EVENTS = {
  REQUEST_EVENT_SUBMITTED: "request_event_submitted",
  CONTACT_FORM_SUBMITTED: "contact_form_submitted",
  REGISTER_SUBMITTED: "register_submitted",
  REGISTRATION_SUBMITTED: "register_submitted",
  LOGIN_SUCCESS: "login_success",
  PASSWORD_RESET_REQUESTED: "password_reset_requested",
  PASSWORD_RESET_COMPLETED: "password_reset_completed",

  PUBLIC_ENTRY_SUBMITTED: "public_entry_submitted",

  VOTE_SUBMITTED: "vote_submitted",
  MANUAL_VOTE_SUBMITTED: "manual_vote_submitted",

  SPONSOR_INQUIRY_SUBMITTED: "sponsor_inquiry_submitted",
  VENDOR_INQUIRY_SUBMITTED: "vendor_inquiry_submitted",
  VOLUNTEER_SIGNUP_SUBMITTED: "volunteer_signup_submitted",
  VOLUNTEER_OPPORTUNITIES_VIEWED: "volunteer_opportunities_viewed",

  SPONSOR_CHECKOUT_STARTED: "sponsor_checkout_started",
  VENDOR_CHECKOUT_STARTED: "vendor_checkout_started",
  TICKET_CHECKOUT_STARTED: "ticket_checkout_started",
  STORE_CHECKOUT_STARTED: "store_checkout_started",
  CHECKOUT_FAILED: "checkout_failed",
  CHECKOUT_CANCELLED: "checkout_cancelled",

  AUCTION_BID_PLACED: "auction_bid_placed",
  AUCTION_REGISTRATION_STARTED: "auction_registration_started",
  AUCTION_REGISTRATION_COMPLETED: "auction_registration_completed",
  AUCTION_CHECKOUT_STARTED: "auction_checkout_started",

  PASSPORT_CODE_REDEEMED: "passport_code_redeemed",
  PASSPORT_QR_SCANNED: "passport_qr_scanned",

  EVENT_INTEREST_SUBMITTED: "event_interest_submitted",
  VOLUNTEER_INTEREST_SUBMITTED: "volunteer_interest_submitted",
  EVENT_SEARCH_SUBMITTED: "event_search_submitted",
  EVENT_SEARCH_NOT_FOUND: "event_search_not_found",

   VOTE_PAGE_VIEWED: "vote_page_viewed",
  VOTE_SUBMIT_CLICKED: "vote_submit_clicked",
  VOTE_CANCELLED: "vote_cancelled",

  MANUAL_VOTE_VIEWED: "manual_vote_viewed",
  MANUAL_VOTE_ENTRY_SELECTED: "manual_vote_entry_selected",

  PASSPORT_SCANNER_OPENED: "passport_scanner_opened",
  PASSPORT_STOP_VIEWED: "passport_stop_viewed",
  PASSPORT_STOP_REDEEMED: "passport_stop_redeemed",

  AUCTION_ITEM_VIEWED: "auction_item_viewed",

  CONTACT_FORM_OPENED: "contact_form_opened",
  MAILING_LIST_OPENED: "mailing_list_opened",
  MAILING_LIST_SIGNUP: "mailing_list_signup", 
  
  BALLOT_VIEWED: "ballot_viewed",
  LEADERBOARD_VIEWED: "leaderboard_viewed",
  ENTRY_LIST_VIEWED: "entry_list_viewed",
  ENTRY_VIEWED: "entry_viewed",
  EVENT_PAGE_VIEWED: "event_page_viewed",
  EVENT_RETURNED: "event_returned",
  EVENT_SCHEDULE_VIEWED: "event_schedule_viewed",
  EVENT_MAP_VIEWED: "event_map_viewed",
  AUCTION_LIST_VIEWED: "auction_list_viewed",
  AUCTION_SEARCH_SUBMITTED: "auction_search_submitted",
  SPONSOR_LIST_VIEWED: "sponsor_list_viewed",
  SPONSOR_VIEWED: "sponsor_viewed",
  SPONSOR_WEBSITE_CLICKED: "sponsor_website_clicked",
  SPONSOR_LEAD_SUBMITTED: "sponsor_lead_submitted",
  VENDOR_VIEWED: "vendor_viewed",
  VENDOR_LIST_VIEWED: "vendor_list_viewed",
  VENDOR_WEBSITE_CLICKED: "vendor_website_clicked",
};
